// A count for a small badge: 2174 becomes 2.2k, 1000 becomes 1k, under 1000 stays as is.
export function compactCount(n) {
  const v = Number(n) || 0;
  if (v < 1000) return String(v);
  const k = Math.round(v / 100) / 10;
  return `${Number.isInteger(k) ? k : k.toFixed(1)}k`;
}
